import { Button, Dropdown, Form, Grid, Icon, Label, Menu, Pagination, Segment, Table } from 'semantic-ui-react';
import { useEffect } from 'react';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { Link } from 'react-router-dom';
import PageContainer from '../../common/PageContainer';
import './AdSlot.scss';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import { adSlotStatus } from '../adslot.constants';
import { SelectField } from '../../common/FormFields';

const AdSlotsSearchPage = ({
  query,
  page,
  history,
  count,
  siteOptions,
  updatePage,
  slots,
  getAdSlots,
  updateQuery,
  firmOptions,
  getFirmsForLookup,
}) => {
  useEffect(() => {
    getFirmsForLookup();
    getAdSlots();
  }, []);

  console.log({ slots });

  return (
    <PageContainer>
      <Menu borderless stackable className="adslot-search-page-menu">
        <Menu.Item header>
          <Icon name="list alternate outline" />
          Ad Slots
        </Menu.Item>
        <Menu.Menu position="right">
          <Menu.Item header>
            <Link to="/ad-slot/create">
              <Button content="New ad slot" icon="plus" positive labelPosition="left" />
            </Link>
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Grid>
        <Grid.Column computer="13">
          <Table compact="very" size="small" collapsing style={{ width: '100%' }}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell>Firm</Table.HeaderCell>
                <Table.HeaderCell>Sites</Table.HeaderCell>
                <Table.HeaderCell>Start date</Table.HeaderCell>
                <Table.HeaderCell>End date</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {slots?.map(slot => (
                <Table.Row key={slot.id}>
                  <Table.Cell>
                    <Button type="button" icon="edit" size="mini" onClick={() => history.push('/ad-slot/' + slot.id)} />
                    <Button
                      type="button"
                      icon="binoculars"
                      size="mini"
                      as="a"
                      href={`${slot?.sites[0]?.site?.apiUrl?.replace('/api', '')}/preview?showcase_id=${
                        slot.id
                      }&displayType=desktop`}
                      target="_blank"
                    />
                  </Table.Cell>
                  <Table.Cell>
                    {slot.firms.map(({ firm }, idx) => (
                      <span key={idx}>{firm.name}</span>
                    ))}
                  </Table.Cell>
                  <Table.Cell>
                    {slot.sites.map(({ site }, idx) => (
                      <Label key={idx} content={site.name} />
                    ))}
                  </Table.Cell>
                  <Table.Cell>{moment(slot.startDate).format('MM/DD/YYYY')}</Table.Cell>
                  <Table.Cell>{moment(slot.endDate).format('MM/DD/YYYY')}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Grid.Column>
        <Grid.Column computer="3">
          <Segment>
            <Formik
              initialValues={query}
              enableReinitialize
              onSubmit={values => {
                updatePage(1);
                updateQuery(values);
                getAdSlots();
              }}
            >
              {formik => (
                <Form className="adslot-search-form" onSubmit={formik.handleSubmit}>
                  <SelectField
                    name="site"
                    options={siteOptions}
                    label="Site"
                    clearable
                    onChange={formik.handleChange}
                    value={formik.values.site}
                    formik={formik}
                  />
                  {/* <FirmDropDown
                    name="firmId"
                    label="Firms"
                    multiple={false}
                    formik={formik}
                    value={formik.values.firmId}
                    onChange={formik.handleChange}
                    error={formik.touched.firmId && Boolean(formik.errors.firmId)}
                    errorMessage={formik.errors.firmId}
                  /> */}

                  <Form.Field error={formik.touched.firmId && Boolean(formik.errors.firmId)}>
                    <label>Firms</label>
                    <Dropdown
                      fluid
                      multiple={false}
                      search
                      selection
                      clearable
                      options={firmOptions}
                      id="firmId"
                      name="firmId"
                      value={firmOptions?.length === 1 ? firmOptions[0]?.value : formik.values.firmId}
                      onChange={(e, d) => formik.setFieldValue('firmId', d.value)}
                    />
                  </Form.Field>
                  <SelectField
                    name="status"
                    options={adSlotStatus}
                    clearable
                    onChange={formik.handleChange}
                    value={formik.values.status}
                    label="Status"
                    formik={formik}
                  />
                  <Button content="Search" type="submit" fluid positive />
                  <br />
                  <Button
                    content="Clear Search"
                    type="button"
                    onClick={() => {
                      formik.resetForm();
                      updateQuery({
                        firmId: '',
                        site: '',
                        status: '',
                      });
                      formik.handleSubmit();
                    }}
                    fluid
                  />
                </Form>
              )}
            </Formik>
          </Segment>
        </Grid.Column>
      </Grid>

      <Grid>
        <Grid.Row centered>
          <Pagination
            activePage={page}
            totalPages={count}
            onPageChange={(e, { activePage }) => {
              updatePage(activePage);
              getAdSlots();
            }}
          />
        </Grid.Row>
      </Grid>
    </PageContainer>
  );
};

const mapStateToProps = state => ({
  slots: selectors.showcase.slots(state),
  query: selectors.showcase.slotQuery(state),
  count: selectors.showcase.slotPageCount(state),
  page: selectors.showcase.slotPage(state),
  siteOptions: selectors.admin.siteOptions(state),
  firmOptions: selectors.firms.allFirmsOptions(state),
});

const mapDispatchToProps = dispatch => ({
  getAdSlots: bindActionCreators(actions.adSlot.getAdSlots, dispatch),
  updateQuery: bindActionCreators(actions.adSlot.updateQuery, dispatch),
  updatePage: bindActionCreators(actions.adSlot.updatePage, dispatch),
  getFirmsForLookup: bindActionCreators(actions.firm.getFirmsForLookup, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdSlotsSearchPage);
